import { Mark } from '@tiptap/core'

const TextFontSize = Mark.create({
  name: 'fontsize',

  addOptions () {
    return {
      class: '',
      fontSize: ['11px'],
      sid: ''
    }
  },

  addAttributes () {
    return {
      class: {
        default: '',
        parseHTML: element => element.getAttribute('class') || ''
      },
      fontSize: {
        default: '11px'
      },
      sid: {
        default: '',
        parseHTML: element => element.getAttribute('data-sid') || ''
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'spans'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    const sid = HTMLAttributes.sid || HTMLAttributes['data-sid'] || ''

    const attrs = {
      ...HTMLAttributes,
      class: `--${sid}-text-size`,
      'data-sid': sid
    }

    delete attrs.fontSize
    delete attrs.sid

    return ['spans', attrs, 0]
  },

  addCommands () {
    return {
      setFontSize: attrs => ({ commands }) => {
        return commands.setMark(this.name, attrs)
      },
      removeFontSize: () => ({ commands }) => {
        return commands.unsetMark(this.name)
      }
    }
  }
})

export default TextFontSize
